/**
 * What a field says when it is flagged empty and has not been given its own
 * message. Labels are sentence case, so the title reads correctly inside the
 * sentence; a title phrased as a question does not, and gets a neutral line.
 *
 * @example defaultRequiredMessage('Employer name') // 'Employer name is required.'
 * @example defaultRequiredMessage('Do you have kids?') // 'Please answer this to continue.'
 */
export function defaultRequiredMessage(title?: string): string {
    const trimmed = title?.trim();
    if (!trimmed) return 'Please complete this to continue.';
    if (trimmed.endsWith('?')) return 'Please answer this to continue.';
    return `${trimmed} is required.`;
}
